<template>
  <div class="dassault-link c-padding-lg--top c-padding-lg--bottom">
    <div v-if="waiting" class="flex-center flex-column">
      <div>
        <c-title 
          :color="waitingTitleFontColor"
          :size="waitingTitleFontSize"
          :weight="waitingTitleFontWeight">
          {{ waitingTitle }}
        </c-title>
      </div>
      <div class="c-margin-lg--top" v-if="waitingMessage">
        <c-text
          :color="waitingDescriptionFontColor"
          :size="waitingDescriptionFontSize"
          :weight="waitingDescriptionFontWeight">
          {{ waitingMessage }}&nbsp;
          <c-icon class="rotate" name="loading" />
        </c-text>
      </div>
    </div>
    <div v-if="link" class="flex-center flex-column">
      <div>
        <c-text
          :color="popupBlockedMessageFontColor"
          :size="popupBlockedMessageFontSize"
          :weight="popupBlockedMessageFontWeight">
          {{ popupBlockedMessage }}
        </c-text>
      </div>
      <div>
        <c-button 
          :radius="openLinkButtonBorderRadius" 
          :bg-color="openLinkButtonBgColor"
          :border-color="openLinkButtonBorderColor"
          emit-to="dassault-link"
          class="c-margin-lg--top c-margin-xl--bottom c-button">
          <c-text
            :color="openLinkButtonTextFontColor"
            :size="openLinkButtonTextFontSize"
            :weight="openLinkButtonTextFontWeight">
            {{ openLinkButtonText }}
          </c-text>
        </c-button>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'dassault-link',
    props: {
      contextId: String,
      sessionId: String,
      apiRefreshSession: String,
      apiGetLink: String,
      apiUnload: String,
      redirectLink: String,
      refreshInterval: {
        type: Number,
        default: 10000
      },
      waitingTitle: {
        type: String,
        default: 'Please wait. We\'re connecting to the platform.'
      },
      waitingTitleFontColor: String,
      waitingTitleFontSize: String,
      waitingTitleFontWeight: String,
      waitingDescription: {
        type: String,
        default: 'You are the number {}'
      },
      waitingDescriptionFontColor: String,
      waitingDescriptionFontSize: String,
      waitingDescriptionFontWeight: String,
      popupBlockedMessage: {
        type: String,
        default: 'If the page doesn\'t open'
      },
      popupBlockedMessageFontColor: String,
      popupBlockedMessageFontSize: String,
      popupBlockedMessageFontWeight: String,
      openLinkButtonText: {
        type: String,
        default: 'Click here to open'
      },
      openLinkButtonTextFontColor: String,
      openLinkButtonTextFontSize: String,
      openLinkButtonTextFontWeight: String,
      openLinkButtonBgColor: String,
      openLinkButtonBorderColor: String,
      openLinkButtonBorderRadius: Number
    },
    data() {
      return {
        waiting: true,
        waitingMessage: 'Loading...',
        link: ''
      }
    },
    created() {
      this.$on('clickbutton', () => this.openNewWindow(this.link))
    },
    methods: {
      tryAgain() {
        this.waiting = true
        setTimeout(() => {
          this.login()
        }, this.refreshInterval)
      },
      openNewWindow(link, event) {
        if (event) event.preventDefault()
        const win = window.open(link, '_blank')
        if (win) {
          this.watchNewWindow(win)
        }
      },
      watchNewWindow(win) {
        const interval = setInterval(() => {
          if (win.closed)
          {
            this.unload().then(() => {
              location.href = this.redirectLink
            })
            clearInterval(interval)
          }
        }, 500)
      },
      login() {
        fetch(this.apiGetLink, getDefaultRequest({ contextId: this.contextId, sessionId: this.sessionId }))
          .then(response => response.json())
          .then(json => {
            if (typeof json === 'string')
            {
              this.tryAgain()
              return
            }
            if (json.Data.Url) {
              this.waiting = false
              this.link = json.Data.Url
              this.waitingMessage = ''
              this.openNewWindow(this.link)
              if (this.apiRefreshSession) {
                this.startRefreshSession()
              }
              return
            }
            this.waitingMessage = this.waitingDescription.replace('{}', json.Data.QueuePosition)
            this.tryAgain()
          })
          .catch(error => window.console.log('Login Error: ', error))
      },
      startRefreshSession() {
        setInterval(() => {
          fetch(this.apiRefreshSession, getDefaultRequest({ contextId: this.contextId, sessionId: this.sessionId }))
            .then(response => response.json())
            .then(json => {
              if (json.Status !== 'ok') {
                location.reload()
              }
            })
            .catch(error => window.console.log('Refresh Session Error: ', error))
        }, this.refreshInterval)
      },
      unload() {
        return fetch(this.apiUnload, getDefaultRequest({ contextId: this.contextId, sessionId: this.sessionId }))
      },
      watchOnUnload() {
        window.addEventListener('unload', () => {
          this.unload()
        })
      }
    },
    mounted() {
      this.login()
      this.watchOnUnload()
    }
  }

  const getDefaultRequest = (requestBody) => {
    const request = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(requestBody)
    }
    return request
  }
</script>
<style>
  .dassault-link{
    background-color: white;
  }
  .flex-center{
    display:flex;
    align-items: center;
    justify-content: center;  
  }
  .flex-column{
    flex-direction: column;
  }
  .rotate {
    animation: rotation 1.3s infinite linear;
  }

  @keyframes rotation {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(359deg);
    }
  }
</style>